import { label } from "./labels";
import { useLocale } from "../i18n";

/** A display summary from the server; lifecycle filters and commands use status. */
export function UnitActivityBadge({ unit }: { unit: Record<string, unknown> }) {
  const { w, lang } = useLocale();
  const status = String(unit.status);
  const summary = status === "PUBLISHED" && ["COMPETITION", "STAGE"].includes(String(unit.unitKind))
    ? unit.activityState : undefined;
  const view = summary === "FINISHED" ? { key: "finished", text: w("منتهية", "Finished") }
    : summary === "NO_ACTIVE_ROUNDS" ? { key: "inactive", text: w("لا توجد جولة فعالة", "No active round") }
    : summary === "UNAVAILABLE" ? { key: "unavailable", text: w("حالة النشاط غير متاحة", "Activity unavailable") }
    : { key: status.toLowerCase(), text: label(status, lang) };
  return <span className={`event-state event-state-${view.key}`}>{view.text}</span>;
}
